// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * The following are shared across all platforms and apps
 */
.filter-list {
  display: flex;
  flex-wrap: wrap;
  font-family: "OpenSans-Regular";
  color: var(--undp-jtf-btn-dark-color);
}

.input-group {
  margin-bottom: 10px;
  padding: 1px 5px;
}

/* Mismo ancho que categorías (tag-selector): el control ocupa el resto del input-group */
.filter-list .input-group {
  flex-wrap: nowrap;
  align-items: stretch;
}
.filter-list .input-group > eview-tag-selector,
.filter-list .input-group > eview-searchable-select {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  max-width: 100%;
}
.filter-list .input-group > .form-control {
  flex: 1 1 auto;
  min-width: 0;
}
.filter-list .input-group .searchable-select,
.filter-list .input-group .searchable-select__input {
  width: 100%;
  max-width: 100%;
}

eview-tag-selector {
  flex: 1 1 auto;
}

.form-group.hidden {
  width: 0;
  margin: 0;
  border: none;
  padding: 0;
}

.custom-day {
  text-align: center;
  padding: 0.185rem 0.25rem;
  display: inline-block;
  height: 2rem;
  width: 2rem;
}

.custom-day.focused {
  background-color: #e6e6e6;
}

.custom-day.range,
.custom-day:hover {
  background-color: rgb(2, 117, 216);
  color: white;
}

.custom-day.faded {
  background-color: rgba(2, 117, 216, 0.5);
}

button.calendar,
button.calendar:active {
  width: 2.75rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAEUSURBVEiJ7ZQxToVAEIY/YCHGxN6XGOIpnpaEsBSeQC9ArZbm9TZ6ADyBNzAhQGGl8Riv4BLAWAgmkpBYkH1b8FWT2WK/zJ8ZJ4qiI6XUI3ANnGKWBnht2/ZBDRK3hgVGNsCd7/ui+JkEIrKtqurLpEWaphd933+IyI3LEIdpCYCiKD6HcuOa/nwOa0ScJEnk0BJg0UTUWJRl6RxCYEzEmomsIlPU3IPW+grIAbquy+q6fluy/28RIBeRMwDXdXMgXLj/B2uimRXpui4D9sBeRLKl+1N+L+t6RwbWrZliTTTr1oxYtzVWiTQAcRxvTX+eJMnlUDaO1vpZRO5NS0x48sIwfPc87xg4B04MCzQi8hIEwe4bl1DnFMCN2zsAAAAASUVORK5CYII=) !important;
  background-repeat: no-repeat;
  background-size: 23px;
  background-position: 50%;
}

.hidden {
  display: none;
}

.btn-link {
  color: #fff;
  background-color: var(--undp-jtf-btn-dark-color);
  margin-left: 20px;
  font-family: "OpenSans-Regular";
  padding: 7px 30px;
  border-color: white;
  text-decoration: none;
}

.btn-link:disabled,
.btn-link.disabled {
  color: #fff;
  background-color: #9aa5b1;
  border-color: #9aa5b1;
  opacity: 0.65;
  cursor: not-allowed;
  pointer-events: none;
  text-decoration: none;
}

.form-filter {
  font-family: "OpenSans-Regular";
  color: var(--undp-jtf-btn-dark-color);
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/filters/filters.component.scss","webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;ADEA;EACE,aAAA;EACA,eAAA;EACA,+BAAA;EACA,qCAAA;AAGF;;AAAA;EACE,mBAAA;EACA,gBAAA;AAGF;;AAAA,yFAAA;AACA;EACE,iBAAA;EACA,oBAAA;AAGF;AADE;;EAEE,cAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAGJ;AAAE;EACE,cAAA;EACA,YAAA;AAEJ;AACE;;EAEE,WAAA;EACA,eAAA;AACJ;;AAGA;EACE,cAAA;AAAF;;AAEA;EACE,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AACF;;AACA;EACE,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;;AADA;;EAEE,kCAAA;EACA,YAAA;AAIF;;AAFA;EACE,wCAAA;AAKF;;AAFA;;EAEE,cAAA;EACA,wlBAAA;EACA,4BAAA;EACA,qBAAA;EACA,wBAAA;AAKF;;AAHA;EACE,aAAA;AAMF;;AAHA;EACE,WAAA;EACA,gDAAA;EACA,iBAAA;EACA,+BE/EqB;EFgFrB,iBAAA;EACA,mBAAA;EACA,qBAAA;AAMF;;AAHA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;AAMF;;AAHA;EACE,+BEjGqB;EFkGrB,qCAAA;AAMF","sourcesContent":["@import '../../../../scss/variables';\n\n.filter-list {\n  display: flex;\n  flex-wrap: wrap;\n  font-family: $primary-font-regular;\n  color: var(--undp-jtf-btn-dark-color); \n}\n\n.input-group {\n  margin-bottom: 10px;\n  padding: 1px 5px;\n}\n\n/* Mismo ancho que categorías (tag-selector): el control ocupa el resto del input-group */\n.filter-list .input-group {\n  flex-wrap: nowrap;\n  align-items: stretch;\n\n  > eview-tag-selector,\n  > eview-searchable-select {\n    display: block;\n    flex: 1 1 auto;\n    min-width: 0;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  > .form-control {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .searchable-select,\n  .searchable-select__input {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\neview-tag-selector {\n  flex: 1 1 auto;\n}\n.form-group.hidden {\n  width: 0;\n  margin: 0;\n  border: none;\n  padding: 0;\n}\n.custom-day {\n  text-align: center;\n  padding: 0.185rem 0.25rem;\n  display: inline-block;\n  height: 2rem;\n  width: 2rem;\n}\n.custom-day.focused {\n  background-color: #e6e6e6;\n}\n.custom-day.range,\n.custom-day:hover {\n  background-color: rgb(2, 117, 216);\n  color: white;\n}\n.custom-day.faded {\n  background-color: rgba(2, 117, 216, 0.5);\n}\n\nbutton.calendar,\nbutton.calendar:active {\n  width: 2.75rem;\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAEUSURBVEiJ7ZQxToVAEIY/YCHGxN6XGOIpnpaEsBSeQC9ArZbm9TZ6ADyBNzAhQGGl8Riv4BLAWAgmkpBYkH1b8FWT2WK/zJ8ZJ4qiI6XUI3ANnGKWBnht2/ZBDRK3hgVGNsCd7/ui+JkEIrKtqurLpEWaphd933+IyI3LEIdpCYCiKD6HcuOa/nwOa0ScJEnk0BJg0UTUWJRl6RxCYEzEmomsIlPU3IPW+grIAbquy+q6fluy/28RIBeRMwDXdXMgXLj/B2uimRXpui4D9sBeRLKl+1N+L+t6RwbWrZliTTTr1oxYtzVWiTQAcRxvTX+eJMnlUDaO1vpZRO5NS0x48sIwfPc87xg4B04MCzQi8hIEwe4bl1DnFMCN2zsAAAAASUVORK5CYII=) !important;\n  background-repeat: no-repeat;\n  background-size: 23px;\n  background-position: 50%;\n}\n.hidden {\n  display: none;\n}\n\n.btn-link {\n  color: #fff;\n  background-color: var(--undp-jtf-btn-dark-color);\n  margin-left: 20px;\n  font-family: $primary-font-regular;\n  padding: 7px 30px;\n  border-color: white;\n  text-decoration: none;\n}\n\n.btn-link:disabled,\n.btn-link.disabled {\n  color: #fff;\n  background-color: #9aa5b1;\n  border-color: #9aa5b1;\n  opacity: 0.65;\n  cursor: not-allowed;\n  pointer-events: none;\n  text-decoration: none;\n}\n\n.form-filter {\n  font-family: $primary-font-regular;\n  color: var(--undp-jtf-btn-dark-color); \n}","/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
